module.exports = __webpack_public_path__ + "static/media/explode3.f3b0a48f.gif";